type CacheType = {
  [key: string]: Object;
};

let CACHE: CacheType = {};

const Cache = {
  get: (key: string) => {
    return CACHE[key];
  },
  set: (key: string, value: any) => {
    CACHE[key] = value;
    return value;
  },
  bust: (key: string) => {
    delete CACHE[key];
  },
  all: () => {
    return CACHE;
  },
  flush: () => {
    CACHE = {};
  },
};

export default Cache;

export function imageCacheKey(id: string, version?: string) {
  return `${imageCachePrefix(id)}${version || '0'}`;
}

export function imageCachePrefix(id: string) {
  return `getImageData/${id}/`;
}
